import request from './../utils/request';

export function index(params) {
  return request({
    url: '/movings',
    method: 'GET',
    params
  });
}

export function show(id) {
  return request({
    url: '/movings/' + id,
    method: 'GET'
  });
}

export function showrem(data) {
  return request({
    url: '/movings/showrem',
    method: 'POST',
    data
  });
}

export function store(data) {
  return request({
    url: '/movings',
    method: 'POST',
    data
  });
}

export function update(data) {
  return request({
    url: '/movings/' + data.id,
    method: 'PUT',
    data
  });
}

export function destroy(id) {
  return request({
    url: '/movings/' + id,
    method: 'DELETE'
  });
}

export function destroyItem(id) {
  return request({
    url: `/movings/item/${id}`,
    method: 'DELETE'
  });
}